import "./index.scss"

import { Button } from "antd"
import { useNavigate } from "react-router-dom"

export const NotFound: React.FC = () => {
    const navigate = useNavigate()

    return (
        <div className="error-container">
            <div className="error-wrapper">
                <div className="error-content">
                    <h1>Something went wrong!</h1>
                    <p>The page you are looking for doesn’t exist or has been removed</p>
                    <Button type="primary" className="waitlist-button" onClick={() => navigate("/")}>Back to Home Page</Button>
                </div>
            </div>
        </div>
    )
}